export module ComponentNames {
    export const baseDimensionsComponent = "BaseDimensionComponent";
    export const collisionBehaviorComponent = "CollisionBehaviorComponent";
    export const dockingBehaviorComponent = "DockingBehaviorComponent";
    export const imageComponent = "ImageComponent";
    export const layerComponent = "LayerComponent";
    export const namingComponent = "NamingComponent";
    export const notClickableComponent = "NotClickableComponent";
    export const placingRestrictorComponent = "PlacingRestrictorComponent";
    export const podestComponent = "PodestComponent";
    export const bedComponent = "BedComponent";
    export const doorComponent = "DoorComponent";
    export const luggageAreaComponent = "LuggageAreaComponent";
    export const nonUsableSpaceComponent = "NonUsableSpaceComponent";
    export const overheadStorageComponent = "OverheadStorageComponent";
    export const rackComponent = "RackComponent";
    export const seatComponent = "SeatComponent";
    export const tableComponent = "TableComponent";
    export const wallComponent = "WallComponent";
    export const classCategoryComponent = "ClassCategoryComponent";
    export const stairsComponent = "StairsComponent";
    export const compartmentContainerComponent = "CompartmentContainerComponent";
    export const containerBaseComponent = "ContainerBaseComponent";
    export const wagonContainerComponent = "WagonContainerComponent";
    export const identificationComponent = "IdentificationComponent";
    export const aisleComponent = 'AisleComponent';
    export const doNotSaveComponent = 'DoNotSaveComponent';
    export const gangwayDoorComponent = 'GangwayDoorComponent';
    export const entranceDoorComponent = 'EntranceDoorComponent';
    export const innerDoorComponent = 'InnerDoorComponent';
    export const armrestBetweenSeatComponent = 'ArmrestBetweenSeatComponent';
    export const seatWithStorageComponent = 'SeatWithStorageComponent';
    export const viewComponent = 'ViewComponent';
    export const multiPurposeAreaComponent = 'MultiPurposeAreaComponent';
    export const standingPlaceOccupancyRateComponent = 'StandingPlaceOccupancyRateComponent';
    export const entryPointComponent = 'EntryPointComponent';
    export const exitPointComponent = 'ExitPointComponent';
    export const adjustableSeatComponent = 'AdjustableSeatComponent';
    export const foldingSeatComponent = 'FoldingSeatComponent';
    export const personsPerSquareMeterComponent = 'PersonsPerSquareMeterComponent';
    export const partitionWallComponent = "PartitionWallComponent";
    export const containerWallComponent = "ContainerWallComponent";
    export const wheelChairBoardingDeviceComponent = "WheelChairBoardingDeviceComponent";
    export const cornerBenchComponent = "CornerBenchComponent";
    export const doesNotLimitEntranceAreaComponent = "DoesNotLimitEntranceAreaComponent";
    export const tweenDeckStairsComponent = "TweenDeckStairsComponent";
    export const floorChangeStairsComponent = "FloorChangeStairsComponent";
    export const passengerSectionStairsComponent = "PassengerSectionStairsComponent";
    export const floorComponent = "FloorComponent";
}